var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('v-layout',{attrs:{"row":"","px-2":"","mt-2":"","justify-end":_vm.right}},[_c('v-icon',{attrs:{"color":"yellow"}},[_vm._v("error_outline")]),_vm._v(" "),_c('p',{staticClass:"mb-0 ml-2 color-red"},[_vm._v("\n    "+_vm._s(_vm.warningText)+"\n  ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3be65f44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_atoms/WarningText.vue
// module id = null
// module chunks = 